/**
 * Scene copy — source of truth for text layers.
 * Also rendered as semantic DOM (real headings/paragraphs).
 * Copy APPROVED by Dave 2026-07-12 (see COPY-DRAFT.md).
 */

export interface ProductLabel {
  id: string;
  name: string;
  /** One sharp line — approved copy. */
  line: string;
}

export interface SceneCopy {
  id: string;
  title: string;
  subtitle?: string;
  body?: string;
}

export const HERO: SceneCopy = {
  id: 'hero',
  title: 'Tamze Fleet',
  subtitle: 'One builder. Twelve ships.',
  body: 'Scroll to bring the fleet in.',
};

export const VOICE_BRIDGE: SceneCopy & { products: ProductLabel[] } = {
  id: 'voice-bridge',
  title: 'Voice Bridge',
  subtitle: 'The fleet listens.',
  products: [
    {
      id: 'assistant',
      name: 'Assistant',
      line: 'Your personal JARVIS.',
    },
    {
      id: 'voice',
      name: 'Voice',
      line: "Say the word, it's executed.",
    },
  ],
};

export const COMMAND: SceneCopy & { products: ProductLabel[] } = {
  id: 'command',
  title: 'Command',
  subtitle: 'The fleet obeys.',
  products: [
    {
      id: 'mission-control',
      name: 'Mission Control',
      line: 'The agentic OS runs the fleet.',
    },
    {
      id: 'dashboard',
      name: 'Dashboard',
      line: 'Every system at your fingertips.',
    },
    {
      id: 'galaxy',
      name: 'Galaxy',
      line: 'Your thoughts mapped as stars.',
    },
  ],
};

export const EVERYDAY_APPS: SceneCopy & { products: ProductLabel[] } = {
  id: 'everyday-apps',
  title: 'Everyday Apps',
  subtitle: 'Off duty, still on board.',
  products: [
    {
      id: 'money',
      name: 'Money',
      line: "No more missing annual renewals that you don't use.",
    },
    {
      id: 'steps',
      name: 'Steps',
      line: 'Help your friends to achieve a healthy lifestyle.',
    },
  ],
};

export const QUANT_SQUADRON: SceneCopy & { products: ProductLabel[] } = {
  id: 'quant-squadron',
  title: 'Quant Squadron',
  subtitle: 'Three vessels. One formation.',
  products: [
    {
      id: 'bench',
      name: 'Bench',
      line: 'Strategies proven with blind analysis.',
    },
    {
      id: 'quant',
      name: 'Quant',
      line: 'AI that tests, learns and executes.',
    },
    {
      id: 'regime',
      name: 'Regime',
      line: 'Alerts changes in the market behavior.',
    },
  ],
};

export const CREATION_BAY: SceneCopy & { products: ProductLabel[] } = {
  id: 'creation-bay',
  title: 'Creation Bay',
  subtitle: 'Where ideas take shape.',
  products: [
    {
      id: 'forge',
      name: 'Forge',
      line: 'Get a rendered scene.',
    },
    {
      id: 'storyboard',
      name: 'Storyboard',
      line: 'Scripts become storyboards.',
    },
  ],
};

export const OUTRO: SceneCopy & { cta: { label: string; href: string } } = {
  id: 'outro',
  title: 'The fleet is growing.',
  subtitle: 'More ships are on the way.',
  cta: {
    label: 'Follow the build',
    href: 'https://github.com/tamze',
  },
};

export const SCENES = [
  HERO,
  VOICE_BRIDGE,
  COMMAND,
  EVERYDAY_APPS,
  QUANT_SQUADRON,
  CREATION_BAY,
  OUTRO,
] as const;
